import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pausePolicy } from '@/policy/api/PausePolicy';

import { FrontendPolicyValidationResult } from '../contexts/ValidationContext';

interface PausePolicyParams {
  uuid: string;
  validations: FrontendPolicyValidationResult;
}

export const usePausePolicy = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ uuid, validations }: PausePolicyParams) =>
      pausePolicy(uuid, validations),
    onSuccess: (_, { uuid }) => {
      queryClient.invalidateQueries({ queryKey: ['policy', uuid] });
      queryClient.invalidateQueries({ queryKey: ['policies'] });
    },
  });

  return {
    pausePolicy: mutateAsync,
    isPausing: isPending,
  };
};
